<style>
  #monthPicker{
    min-width: 350px;
    max-width: 350px;
    background: #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
  }

  #yearWrapper{
    padding: 0.5em 1em;
  }

  #yearWrapper span{
    font-size: 1.7em;
    color: #555;
  }

  #yearWrapper button{
    background: transparent;
    border: 1px solid #aaa;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    outline: none;
  }

  #yearWrapper button:disabled{
    opacity: 0.3;
    pointer-events: none;
  }

  #monthsWrapper{
    border-top: 1px solid #d5d5d5;
  }

  #monthsWrapper > button{
    flex-shrink: 0;
    width: 33.333%;
    height: 60px;
    position: relative;
    color: #555;
    background: transparent;
    border: none;
    outline: none;
  }

  #monthsWrapper > button.active{
    background: #d8d8d8;
  }

  #monthsWrapper > button:not(:nth-of-type(3n)){
    border-right: 1px solid #d5d5d5;
  }

  #monthsWrapper > button:not(:nth-of-type(n + 10)){
    border-bottom: 1px solid #d5d5d5;
  }

  #monthsWrapper > button span{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
  }

  #monthsWrapper > button:disabled{
    background: transparent;
    opacity: 0.4;
    pointer-events: none;
  }
</style>

<template>
  <div id="monthPicker">
    <div id="yearWrapper" class="d-flex align-items-center justify-content-between">
      <button 
        :disabled="selectedYear <= minYear"
        @click="setYear(selectedYear - 1)">
        <i class="nav-icon icon-arrow-left"></i>
      </button>
      <span>
        {{ selectedYear }}
      </span>
      <button 
        :disabled="maxYear !== null && selectedYear >= maxYear"
        @click="setYear(selectedYear + 1)">
        <i class="nav-icon icon-arrow-right"></i>
      </button>
    </div>
    <div id="monthsWrapper" class="d-flex flex-wrap">
      <button v-for="(month, index) in months"
        :class="{'active': selectedMonth === index}"
        :key="index"
        @click="setMonth(index)"
        :disabled="(selectedYear === maxYear && index > maxMonth) || (selectedYear === minYear && index < minMonth)">
        <span>{{ month }}</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MonthPicker',
    props: {
      value: Object,
      max: Date | String,
      min: Date | String,
    },
    mounted(){
      if(this.value){
        const { year, month } = this.value;
        if(month && year){
          this.selectedYear = year;
          this.selectedMonth = month;
        }
      }

      if(this.max){
        const maxDate = new Date(this.max);
        this.maxYear = maxDate.getFullYear();
        this.maxMonth = maxDate.getMonth();
      }

      if(this.min){
        const minDate = new Date(this.min);
        this.minYear = minDate.getFullYear();
        this.minMonth = minDate.getMonth();
      }
    },
    created(){
      this.selectedYear = new Date().getFullYear();
      this.selectedMonth = new Date().getMonth();
      this.emitNewValue();
    },
    data: function(){
      return {
        months : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
        selectedYear: null,
        selectedMonth: null,
        // selectedMonth: new Date().getMonth(),
        maxYear: null,
        maxMonth: null,
        minYear: 0,
        minMonth: null,
      };
    },
    methods: {
      setYear(year){
        this.selectedYear = year;
        this.emitNewValue();
      },
      setMonth(month){
        this.selectedMonth = month;
        this.emitNewValue();
      },
      emitNewValue(){
        this.$nextTick(function(){
          this.$emit('input', {
            year: this.selectedYear,
            month: this.selectedMonth
          });
        });
      }
    }
  }
</script>
